
import { stationOptions } from "constants/ticketConstants";

const getStationValue =( )=>{
  if(localStorage.getItem("lastUsedPrinter")){
    return stationOptions.find(s => s.value === localStorage.getItem("lastUsedPrinter"));
  }
  else{
    return { value: "", label: "None" };
  }
}

export const initialState = {
  
  receipts: {
    allReceipts: [],
    page: 0,
    count: 0,
    error: null,
  },
  addReceiptFormdetails: {
    payment: { value: "cash", label: "Cash" },
    paymentType: { value: "full", label: "Full" },
    phone: "",
    booth: { name: ""},
    printer: getStationValue(),
    storeId: 1,
    clerk: { id: "", first_name: "" },
    fromx: {name:"" },
    keyword: "",
    lastName: "",
    firstName: "",
    note: "",
    checkNumber: "",
    tendered: "",
    creditCardNumber:"",
    ticketAmount: "",
    requireShipmentFreeTax: false,
    shippingAddress: "",
    shippingState: "",
    shippingCity: "",
    shippingPostalCode: "",
    shippingPhone: "",
    shippingTrackingNumber: ""
  },
  receiptItemdetails: {
    items: [],
    count: 0,
  },
  receiptPaymentItemdetails: {
    items: [],
    count: 0
  }
};


